/* haute feels — simple click-to-expand lightbox for product images */
(function(){
  function pickSrc(img) {
    if (img.dataset && img.dataset.src) return img.dataset.src;
    if (img.src && !img.src.endsWith('/')) return img.src;
    var ss = img.getAttribute('srcset');
    if (ss) {
      var parts = ss.split(',');
      var last = parts[parts.length - 1].trim().split(' ')[0];
      return last;
    }
    return null;
  }

  function openLightbox(src) {
    if (!src) return;
    var overlay = document.createElement('div');
    overlay.className = 'hf-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:99999',
      'background:rgba(255,255,255,0.96)',
      'display:flex', 'align-items:center', 'justify-content:center',
      'cursor:zoom-out', 'padding:32px',
      'animation:hfLightboxFadeIn 180ms ease'
    ].join(';');

    var img = document.createElement('img');
    img.src = src;
    img.style.cssText = [
      'max-width:92vw', 'max-height:92vh',
      'width:auto', 'height:auto',
      'object-fit:contain',
      'box-shadow:0 12px 48px rgba(123,140,156,0.28)',
      'border:1px solid rgba(123,140,156,0.22)',
      'background:#fff', 'cursor:zoom-out',
      'transition:transform 200ms ease'
    ].join(';');
    overlay.appendChild(img);

    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = '✕';
    close.setAttribute('aria-label', 'close');
    close.style.cssText = [
      'position:absolute', 'top:16px', 'right:20px',
      'background:transparent', 'border:1px solid rgba(123,140,156,0.4)',
      'color:#7b8c9c', 'width:36px', 'height:36px',
      'font-size:14px', 'line-height:1', 'cursor:pointer',
      'font-family:"Michroma","Space Mono",sans-serif'
    ].join(';');
    overlay.appendChild(close);

    function destroy() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    }
    function onKey(e) {
      if (e.key === 'Escape') destroy();
    }
    overlay.addEventListener('click', destroy);
    img.addEventListener('click', function(e){ e.stopPropagation(); destroy(); });
    close.addEventListener('click', function(e){ e.stopPropagation(); destroy(); });
    document.addEventListener('keydown', onKey);

    document.body.style.overflow = 'hidden';
    document.body.appendChild(overlay);
  }

  function bind(root) {
    var imgs = (root || document).querySelectorAll(
      '.product__media-item img, .product__media img, .product-media img, .product__modal-opener img'
    );
    imgs.forEach(function(img) {
      if (img.dataset.hfBound) return;
      img.dataset.hfBound = '1';
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(pickSrc(img));
      }, true);
    });
    // also intercept modal-opener wrappers so the lightbox opens even if
    // dawn's product modal is hooked to them
    var openers = (root || document).querySelectorAll(
      '.product__modal-opener, modal-opener.product__modal-opener'
    );
    openers.forEach(function(op) {
      if (op.dataset.hfBound) return;
      op.dataset.hfBound = '1';
      op.style.cursor = 'zoom-in';
      op.addEventListener('click', function(e) {
        var img = op.querySelector('img');
        if (!img) return;
        e.preventDefault();
        e.stopPropagation();
        openLightbox(pickSrc(img));
      }, true);
    });
  }

  var style = document.createElement('style');
  style.textContent = '@keyframes hfLightboxFadeIn { from { opacity: 0 } to { opacity: 1 } }';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ bind(); });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', function(e){ bind(e.target); });
})();
